import React,{useEffect, useState} from 'react'
import { redirect } from 'react-router-dom'
import {connect, useSelector} from 'react-redux'
import { useNavigate,useParams } from 'react-router-dom'
import axios from 'axios'
import auth from '../../../redux/actions/auth'
import { BsFillEyeFill,BsFillEyeSlashFill } from 'react-icons/bs'
import { ToastContainer, toast } from 'react-toastify'
import "react-toastify/dist/ReactToastify.css"

import "./style.css"
import { FRONTEND_ROUTE } from '../../../routes/api/api_routes'

const ResetPasswordConfirm = () => {

    const params = useParams()
    const uid = params.uid
    const token = params.token

    const [formData,setFormData] = useState({
        new_password:"",
        re_new_password:"",
    })

    const [showPassword,setShowpassword] = useState(false)
    const [showPasswordConfirm,setShowpasswordConfirm] = useState(false)


    const [requestSent,setRequestSent] = useState(false)
    const [error, setError] = useState(false)
    const {new_password,re_new_password} = formData


    const onChange = e=> {
        setFormData({...formData,[e.target.name]: e.target.value})
        setError(false)
    }
  
    const onSubmit = e => {
        e.preventDefault();
        if(new_password!=re_new_password){
            setError(true)
        }
        else{
            setError(false)
            console.log("UID: ",uid)
            console.log("token: ",token)
            console.log("password: ",new_password)
            console.log("re_password: ",re_new_password)
            auth.reset_password_confirm(uid,token,new_password,re_new_password)
            notify()
            setRequestSent(true)
        }


    }

    const notify = ()=>{
        toast('Mot de passe modifier avec succès')
     }

   /*useEffect(()=>{
    setTimeout(()=>{
        if (requestSent){
          window.location.replace(`${FRONTEND_ROUTE}/login`);
        }
    },4000)
   },[requestSent])*/
  
    return (
    <div className='container mt-5'>
        <h1 style={{marginBottom: "15px"}}>Modifier votre mot de passe</h1>
        
        <form onSubmit={e=>onSubmit(e)}>
            <div className='form-group'>
                <div className='input-group reset'>
                    <input 
                        className='form-control'
                        type={showPassword?'text':'password'}
                        placeholder='Mot de passe'
                        name='new_password'
                        value={new_password}
                        onChange={e=>onChange(e)}
                        minLength="6"
                        required
                    />
                    <button type='button'  onClick={e=>setShowpassword(!showPassword)} >{!showPassword?<BsFillEyeSlashFill/>:<BsFillEyeFill/>} </button>
                </div>
                
            </div>
            <div className='form-group' style={{margin:"15px 0px"}}>
                <div className='input-group reset'>
                    <input 
                        className='form-control'
                        type={showPasswordConfirm?'text':'password'}
                        placeholder='Confirmer votre mot de passe'
                        name='re_new_password'
                        value={re_new_password}
                        onChange={e=>onChange(e)}
                        minLength="6"
                        required
                    />
                    <button type='button'  onClick={e=>setShowpasswordConfirm(!showPasswordConfirm)}>{!showPasswordConfirm?<BsFillEyeSlashFill/>:<BsFillEyeFill/>} </button>
                </div>
                {error?<p style={{color:"red"}}>Mots de passe non identiques</p>:""}
            </div>
            
            <button className='btn btn-primary' type='submit'>Apply</button>
          
        </form>
        <ToastContainer />
    </div>
  )
}


export default ResetPasswordConfirm;